import { useMemo } from 'react';
import { i18nInit } from '@elfsight/lib-i18n';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { Portal, PortalNestProvider } from '@elfsight/widget-modal';
import { CustomCSS, createCustomCSSPrefixClassName } from '@elfsight/widget-ui';
import { StorageProvider } from '@elfsight/widget-utils';
import { I18nProvider } from '@lingui/react';
import { useSettings } from '@wu/widget-core';
import {
  API_FORM_SERVICE_NAME,
  API_STATIC_ENDPOINTS_SCHEMA,
  meta
} from './constants';
import { useIsAPISchemaTimeoutEnabled } from './utils';
import { useWillFormServiceBeRegistered } from './widget/banner';
import { Empty } from './widget/Empty';
import { Widget } from './widget/Widget';

export function Popup() {
  const popupSettings = useSettings();
  const { widgetId, editMode, renderThumbnailMode, customCSS, customJS } =
    popupSettings;

  const willFormServiceBeRegistered = useWillFormServiceBeRegistered();
  const isAPISchemaTimeoutEnabled = useIsAPISchemaTimeoutEnabled();

  useDefineAPISchema(
    {
      ...API_STATIC_ENDPOINTS_SCHEMA,
      [API_FORM_SERVICE_NAME]: willFormServiceBeRegistered
    },
    isAPISchemaTimeoutEnabled
  );
  useCustomJS(customJS, editMode || renderThumbnailMode);

  const i18n = useMemo(() => i18nInit(), []);

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.alias,
    widgetId
  );

  return (
    <I18nProvider i18n={i18n}>
      <StorageProvider widgetId={widgetId!} name={meta.name}>
        <Empty />
        <PortalNestProvider customCSSClassName={customCSSPrefixClassName}>
          <Portal>
            <Widget />
            <CustomCSS
              customCSS={customCSS}
              prefixClassName={customCSSPrefixClassName}
            />
          </Portal>
        </PortalNestProvider>
      </StorageProvider>
    </I18nProvider>
  );
}
